const development = 'dev-dist/sw.js'
const prodSw = '/sw.js'
if ('serviceWorker' in navigator) {
  // navigator.serviceWorker.addEventListener('controllerchange', () => {
  //   window.location.reload() // Refresh the page when SW updates
  // })
  navigator.serviceWorker.ready.then(registration => {
    registration.periodicSync.register('check-for-update', {
      minInterval: 1 * 60 * 60 * 1000, // פעם בשעה
    })
  })
  navigator.serviceWorker
    .register(import.meta.env.MODE === 'development' ? development : prodSw)
    .then(registration => {
      registration.onupdatefound = () => {
        const installingWorker = registration.installing
        installingWorker.onstatechange = () => {
          if (installingWorker.state === 'installed') {
            if (navigator.serviceWorker.controller) {
              registration.update()
              // window.location.reload() // Reload the page to load the new version
            }
          }
        }
      }
    })
}
